import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row turn-container" }
const _hoisted_2 = { class: "col-md-12 text-center" }
const _hoisted_3 = { id: "turn-seconds-wrapper" }
const _hoisted_4 = {
  key: 1,
  id: "turn-seconds",
  class: /*#__PURE__*/_normalizeClass(['completed'])
}
const _hoisted_5 = { class: "col-lg-6 col-md-6 col-sm-12" }
const _hoisted_6 = { class: "col-lg-6 col-md-6 col-sm-12" }
const _hoisted_7 = { class: "row footer" }
const _hoisted_8 = { class: "modal-wrapper" }
const _hoisted_9 = { class: "modal-container" }
const _hoisted_10 = { class: "modal-body" }
const _hoisted_11 = { class: "modal-footer" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "glyphicon glyphicon-remove" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" CLOSE ")
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DragonCards = _resolveComponent("DragonCards")!
  const _component_TigerCards = _resolveComponent("TigerCards")!
  const _component_DealerActions = _resolveComponent("DealerActions")!
  const _component_CardList = _resolveComponent("CardList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.room.state === 1 && _ctx.gameTimer > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                id: "turn-seconds",
                class: _normalizeClass([_ctx.gameTimer <= 5 ? 'nomore' : ''])
              }, _toDisplayString(_ctx.gameTimer), 3))
            : _createCommentVNode("", true),
          (_ctx.room.state === 3 && _ctx.autoTimer > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.autoTimer), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          id: "turn-status",
          class: _normalizeClass([
          _ctx.room.state === 0 ? 'ready' : '',
          _ctx.room.state === 1 && _ctx.gameTimer > 0 ? 'bet' : '',
          _ctx.room.state === 2 ? 'stop' : '',
          _ctx.room.state === 3 && _ctx.room.result !== 'q' ? 'completed' : '',
          _ctx.room.state === 3 && _ctx.room.result === 'q' ? 'cancelled' : '',
          _ctx.room.state === 4 ? 'shuffle' : '',
          _ctx.gameTimer <= 5 && _ctx.room.state === 1 ? 'nomore' : '',
        ])
        }, _toDisplayString(_ctx.getStatusText() !== "" ? _ctx.$t("betStatus." + _ctx.getStatusText()) : ""), 3)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["row", [{ 'select-disabled': _ctx.room.state != 2 }]])
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_DragonCards, {
          cards: _ctx.dragonCards,
          score: _ctx.dragonScore,
          onCardModal: _ctx.toggleCardModal,
          winner: _ctx.room.result,
          state: _ctx.room.state
        }, null, 8, ["cards", "score", "onCardModal", "winner", "state"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_TigerCards, {
          cards: _ctx.tigerCards,
          score: _ctx.tigerScore,
          onCardModal: _ctx.toggleCardModal,
          winner: _ctx.room.result,
          state: _ctx.room.state
        }, null, 8, ["cards", "score", "onCardModal", "winner", "state"])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_DealerActions, {
        room: _ctx.room,
        tigerCards: _ctx.tigerCards,
        dragonCards: _ctx.dragonCards
      }, null, 8, ["room", "tigerCards", "dragonCards"])
    ]),
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (_ctx.showModal)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "modal-mask",
              onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModal = false))
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_CardList, {
                      onSelectedCard: _ctx.selectedCard,
                      disabledcards: _ctx.disabledcards
                    }, null, 8, ["onSelectedCard", "disabledcards"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-success btn-success pull-right",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal = false))
                    }, _hoisted_14)
                  ])
                ])
              ])
            ], 32))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}